import React, { useState } from 'react';
import { SIPARIS_TASLAK_DEFS } from '../../constants/siparisTaslak';
import { appendParcaToSiparisTaslak } from '../../services/siparisTaslakService';
import IntegerInput from '../IntegerInput';
import { parseAdet } from '../../utils/integerInput';
import './SiparisTaslakEkleModal.css';

const getErrorMessage = (error, fallback) => {
  if (!error) return fallback;
  return error?.message || error?.data?.mesaj || fallback;
};

const SiparisTaslakEkleModal = ({ open, onClose, parca, onSuccess }) => {
  const [selectedTip, setSelectedTip] = useState(SIPARIS_TASLAK_DEFS[0].tip);
  const [adet, setAdet] = useState('1');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!open || !parca) return null;

  const baslik = [parca.parcaAdi || 'Parça', parca.parcaKodu ? `(${parca.parcaKodu})` : '']
    .filter(Boolean)
    .join(' ');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const n = parseAdet(adet, { min: 1, max: 9999 });
    if (!n || n < 1) {
      setError('Geçerli bir adet girin');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await appendParcaToSiparisTaslak(selectedTip, parca, n);
      const def = SIPARIS_TASLAK_DEFS.find((d) => d.tip === selectedTip);
      window.showNotification?.(
        'success',
        `${baslik} — ${def?.shortLabel || 'Taslak'} taslağına eklendi`,
      );
      onSuccess?.(selectedTip);
      onClose();
    } catch (err) {
      setError(getErrorMessage(err, 'Taslak kaydedilemedi'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="modal-overlay siparis-taslak-ekle-modal"
      onClick={() => !submitting && onClose()}
      role="presentation"
    >
      <div className="modal-content siparis-taslak-ekle-modal__content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h2>Sipariş taslağına ekle</h2>
            <p className="siparis-taslak-ekle-modal__subtitle">{baslik}</p>
          </div>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times" />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && <div className="alert alert-danger" style={{ marginBottom: '12px' }}>{error}</div>}
            <p className="siparis-taslak-ekle-modal__hint">
              Parçayı hangi sipariş taslağına eklemek istediğinizi seçin. Siparişler sayfasından taslağı tamamlayıp gönderebilirsiniz.
            </p>
            <div className="siparis-taslak-ekle-modal__choices">
              {SIPARIS_TASLAK_DEFS.map((def) => (
                <label
                  key={def.tip}
                  className={`siparis-taslak-ekle-modal__choice${selectedTip === def.tip ? ' is-selected' : ''}`}
                >
                  <input
                    type="radio"
                    name="siparis-taslak-tip"
                    value={def.tip}
                    checked={selectedTip === def.tip}
                    onChange={() => setSelectedTip(def.tip)}
                  />
                  <span className="siparis-taslak-ekle-modal__choice-icon" style={{ color: def.color }}>
                    <i className={`fas ${def.icon}`} aria-hidden />
                  </span>
                  <span className="siparis-taslak-ekle-modal__choice-label">{def.shortLabel}</span>
                </label>
              ))}
            </div>
            <div className="form-group" style={{ marginTop: '16px' }}>
              <label htmlFor="siparis-taslak-adet" style={{ fontWeight: 500, display: 'block', marginBottom: '6px' }}>
                Adet
              </label>
              <IntegerInput
                id="siparis-taslak-adet"
                min={1}
                max={9999}
                value={adet}
                onChange={setAdet}
                style={{ width: '120px', padding: '8px 12px', borderRadius: '6px', border: '1px solid var(--border-color)' }}
              />
            </div>
          </div>
          <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
            <button type="button" className="secondary-btn" disabled={submitting} onClick={onClose}>
              İptal
            </button>
            <button type="submit" className="primary-btn" disabled={submitting}>
              {submitting ? 'Ekleniyor…' : 'Taslağa ekle'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SiparisTaslakEkleModal;
